import { IconColor } from '@/components/ui/icons/DynamicIcon/types/colors';
import { ThemeOptions } from '@mui/material/styles/createTheme';
import { colors } from '@/styles/theme/colors';
import { getCssVariable } from '@/styles/utils/getCssVariable';

export const palette = {
  primary: {
    //configuration/primary on design
    main: getCssVariable('--dark-primary-main', colors.blue._650),
    light: getCssVariable('--dark-primary-light', colors.transparent._50),
    dark: getCssVariable('--dark-primary-dark', colors.blue._500),
  },
  secondary: {
    //configuration/secondary on design
    main: getCssVariable('--dark-secondary-main', colors.blue._400),
    deep: getCssVariable('--dark-secondary-deep', colors.transparent._100),
    light: getCssVariable('--dark-secondary-light', colors.grey._950),
  },
  validation: {
    error: getCssVariable('--error-dark', colors.red._350),
    warning: getCssVariable('--error-dark', colors.orange._450),
    info: getCssVariable('--error-dark', colors.blue._650),
  },
  background: {
    primary: getCssVariable('--dark-background-primary', colors.grey._850),
    navigation: getCssVariable('--dark-background-navigation', colors.blue._1000),
    card: getCssVariable('--dark-background-card', colors.black._50),
    secondary: getCssVariable('--dark-background-secondary', colors.blue._1000),
    cardHeader: getCssVariable('--dark-background-cardHeader', colors.blue._1000),
    cardRemainingDays: getCssVariable('--dark-background-cardRemainingDays', colors.red._600),
    editMode: getCssVariable('--dark-background-editMode', colors.grey._800),
    editModeInput: getCssVariable('--dark-background-editModeInput', colors.grey._800),
    iconGray: getCssVariable('--dark-background-iconGray', colors.grey._250),
  },
  tags: {
    blueLight: getCssVariable('--dark-tags-blueLight', colors.blue._350),
    blueDark: getCssVariable('--dark-tags-blueDark', colors.blue._800),
    deepGreenLight: getCssVariable('--dark-tags-deepGreenLight', colors.blue._400),
    deepGreenDark: getCssVariable('--dark-tags-deepGreenDark', colors.green._100),
    deepGreen: getCssVariable('--dark-tags-deepGreen', colors.blue._400),
    redLight: getCssVariable('--dark-tags-redLight', colors.red._150),
    redDark: getCssVariable('--dark-tags-redDark', colors.red._200),
    greyLight: getCssVariable('--dark-tags-greyLight', colors.grey._700),
    greyDark: getCssVariable('--dark-tags-greyDark', colors.grey._200),
    staticGreyDark: getCssVariable('--tags-staticGreyDark', colors.grey._600),
    greenLight: getCssVariable('--dark-tags-greenLight', colors.green._300),
    greenDark: getCssVariable('--dark-tags-greenDark', colors.green._550),
    purpleLight: getCssVariable('--dark-tags-purpleLight', colors.purple._250),
    purpleDark: getCssVariable('--dark-tags-purpleDark', colors.purple._100),
    black: getCssVariable('--dark-tags-black', colors.blue._1000),
  },
  success: {
    contrastText: getCssVariable('--dark-success-contrastText', colors.grey._1000),
    main: getCssVariable('--dark-success-main', colors.green._400),
    light: getCssVariable('--dark-success-light', colors.green._550),
    dark: getCssVariable('--dark-success-dark', colors.green._350),
    darkText: getCssVariable('--dark-success-darkText', colors.green._200),
    lightBackground: getCssVariable('--dark-success-lightBackground', colors.green._700),
  },
  error: {
    contrastText: getCssVariable('--dark-error-contrastText', colors.grey._1000),
    main: getCssVariable('--dark-error-main', colors.red._300),
    light: getCssVariable('--dark-error-light', colors.red._350),
    dark: getCssVariable('--dark-error-dark', colors.red._250),
    darkText: getCssVariable('--dark-error-darkText', colors.red._100),
    lightBackground: getCssVariable('--dark-error-lightBackground', colors.red._550),
  },
  warning: {
    contrastText: getCssVariable('--dark-warning-contrastText', colors.orange._50),
    main: getCssVariable('--dark-warning-main', colors.orange._350),
    light: getCssVariable('--dark-warning-light', colors.orange._400),
    dark: getCssVariable('--dark-warning-dark', colors.orange._250),
    darkText: getCssVariable('--dark-warning-darkText', colors.orange._50),
    lightBackground: getCssVariable('--dark-warning-lightBackground', colors.orange._500),
  },
  button: {
    lightBackground: getCssVariable('--dark-button-lightBackground', colors.blue._150),
    border: getCssVariable('--dark-button-border', colors.blue._600),
    disabled: getCssVariable('--dark-button-disabled', colors.grey._600),
    background: getCssVariable('--dark-button-background', colors.black._50),
    main: getCssVariable('--dark-button-main', colors.blue._700),
    switchBackground: getCssVariable('--dark-button-switchBackground', colors.grey._50),
  },
  inputField: {
    default: getCssVariable('--dark-inputField-default', colors.purple._50),
    hover: getCssVariable('--dark-inputField-hover', colors.grey._50),
    focused: getCssVariable('-inputField-focused', colors.blue._600),
    error: getCssVariable('--dark-inputField-error', colors.red._250),
    fillLight: getCssVariable('-inputField-fillLight', colors.grey._850),
    fillDark: getCssVariable('-inputField-fillDark', colors.grey._150),
  },
  skeleton: {
    default: getCssVariable('--dark-skeleton-default', colors.grey._150),
  },
  other: {
    notification: getCssVariable('--dark-other-notification', colors.red._250),
    divider: getCssVariable('--dark-other-divider', colors.grey._400),
    information: getCssVariable('--dark-other-information', colors.grey._250),
    informationLight: getCssVariable('--dark-other-informationLight', colors.grey._450),
    avatar: getCssVariable('--dark-other-avatar', colors.grey._650),
    white: getCssVariable('--dark-other-white', colors.grey._50),
    black: getCssVariable('--dark-other-black', colors.grey._1000),
    editModeBorder: getCssVariable('--dark-other-editModeBorder', colors.grey._700),
    editModeIcon: getCssVariable('--dark-other-editModeIcon', colors.grey._50),
    contrastColor: getCssVariable('--dark-other-contrastColor', colors.grey._50),
    greyHover: getCssVariable('--dark-other-greyHover', colors.grey._150),
    header: getCssVariable('--dark-other-header', colors.blue._1000),
    headerSearch: getCssVariable('--dark-other-headerSearch', colors.grey._850),
    text: getCssVariable('--dark-other-text', colors.white._100),
    blueHover: getCssVariable('--dark-other-blueHover', colors.blue._200),
    searchBackdrop: getCssVariable('--dark-other-searchBackdrop', colors.transparent._350),
    warningBackground: getCssVariable('--dark-other-warningBackground', colors.orange._50),
    successBackground: getCssVariable('--dark-other-successBackground', colors.green._50),
    errorBackground: getCssVariable('--dark-other-errorBackground', colors.red._100),
    darkSecondary: getCssVariable('--dark-other-darkSecondary', colors.black._50),
    selectedDate: getCssVariable('--dark-other-selectedDate', colors.blue._650),
    dashedBorder: getCssVariable('--dark-other-dashedBorder', colors.grey._500),
    boxShadow: getCssVariable('--dark-other-boxShadow', colors.transparent._200),
    lightBorder: getCssVariable('--dark-other-lightBorder', colors.blue._350),
  },
  table: {
    text: {
      secondaryLight: getCssVariable('--table-text-secondary-light', colors.grey._50),
      deepBlue: getCssVariable('--table-text-deep-blue', colors.blue._500),
    },
    surface: {
      primary: getCssVariable('--table-surface-primary', colors.grey._950),
      grayLight: getCssVariable('--table-surface-grey-light', colors.grey._800),
    },
  },
  surface: {
    white: getCssVariable('--dark-surface-white', colors.grey._900),
    primary: getCssVariable('--dark-surface-primary', colors.grey._950),
    secondary: getCssVariable('--dark-surface-secondary', colors.blue._950),
    blue: getCssVariable('--dark-surface-blue', colors.grey._800),
    transparentLight: getCssVariable('--dark-surface-transparent-light', colors.transparent._150),
    transparent: getCssVariable('--dark-surface-transparent', colors.transparent._250),
    greyInverted: getCssVariable('--dark-grey-inverted', colors.grey._850),
  },
  accent: {
    secondary: getCssVariable('--dark-accent-secondary', colors.grey._800),
    primary: getCssVariable('--dark-accent-primary', colors.blue._650),
    primaryDarkStatic: getCssVariable('--dark-accent-primaryDarkStatic', colors.blue._750),
    primaryStatic: getCssVariable('--dark-accent-primaryStatic', colors.blue._700),
  },
  configuration: {
    primary: {
      main: getCssVariable('--dark-configuration-primary-main', colors.blue._650),
      deep: getCssVariable('--dark-configuration-primary-deep', colors.transparent._100),
      light: getCssVariable('--dark-configuration-primary-light', colors.transparent._50),
    },
    secondary: {
      main: getCssVariable('--dark-configuration-secondary-main', colors.blue._400),
      deep: getCssVariable('--dark-configuration-deep-main', colors.transparent._100),
      light: getCssVariable('--dark-configuration-light-main', colors.grey._950),
    },
  },
  information: {
    orangeDarkInverted: getCssVariable('--dark-information-orangeDarkInverted', colors.orange._600),
    orangeLight: getCssVariable('--dark-information-orangeLight', colors.orange._450),
    redLight: getCssVariable('--dark-information-redLight', colors.red._550),
    redDarkInverted: getCssVariable('--dark-information-redDarkInverted', colors.red._500),
    grey: getCssVariable('--dark-information-grey', colors.grey._800),
    greyLight: getCssVariable('--dark-information-greyLight', colors.grey._800),
    blueLight: getCssVariable('--dark-information-blueLight', colors.transparent._50),
    deepBlue: getCssVariable('--dark-information-deepBlue', colors.grey._900),
    pinkLight: getCssVariable('--dark-information-pinkLight', colors.pink._350),
    deepGreen: getCssVariable('--dark-information-deepGreen', colors.green._600),
    purple: getCssVariable('--dark-information-purple', colors.purple._300),
  },
  border: {
    blue: getCssVariable('--border-blue', colors.blue._650),
    deepBlue: getCssVariable('--dark-border-deepBlue', colors.grey._700),
    deepBlueDark: getCssVariable('--dark-border-deepBlueDark', colors.blue._550),
    orange: getCssVariable('--dark-border-orange', colors.orange._300),
    orangeDark: getCssVariable('--dark-border-orangeDark', colors.orange._250),
    red: getCssVariable('--dark-border-red', colors.red._300),
    blueLight: getCssVariable('--dark-border-blueLight', colors.transparent._100),
    whiteInverted: getCssVariable('--dark-border-whiteInverted', colors.transparent._100),
    grey: getCssVariable('--dark-border-grey', colors.grey._800),
  },
  icon: {
    [IconColor.Info]: getCssVariable(`--dark-icon-${IconColor.Info}`, colors.blue._700),
    [IconColor.VectorAdaptiveTertiaryDark]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveTertiaryDark}`,
      colors.grey._400,
    ),
    [IconColor.VectorAdaptiveDark]: getCssVariable(`--dark-icon-${IconColor.VectorAdaptiveDark}`, colors.grey._50),
    [IconColor.VectorAdaptivePrimary]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptivePrimary}`,
      colors.grey._250,
    ),
    [IconColor.VectorAdaptiveBlueLight]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveBlueLight}`,
      colors.blue._650,
    ),
    [IconColor.VectorAdaptiveBlueDark]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveBlueDark}`,
      colors.blue._800,
    ),
    [IconColor.VectorAdaptiveOrange]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveOrange}`,
      colors.orange._300,
    ),
    [IconColor.VectorAdaptiveRedLight]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveRedLight}`,
      colors.red._250,
    ),
    [IconColor.VectorStaticWhite]: getCssVariable(`--dark-icon-${IconColor.VectorStaticWhite}`, colors.grey._50),
    [IconColor.VectorAdaptiveGreyInverted]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptiveGreyInverted}`,
      colors.grey._500,
    ),
    [IconColor.VectorAdaptiveGrey]: getCssVariable(`--dark-icon-${IconColor.VectorAdaptiveGrey}`, colors.grey._700),
    [IconColor.VectorAdaptivePurple]: getCssVariable(
      `--dark-icon-${IconColor.VectorAdaptivePurple}`,
      colors.purple._400,
    ),
  },
  text: {
    primary: getCssVariable('--dark-text-primary', colors.grey._50),
    secondary: getCssVariable('--dark-text-secondary', colors.grey._400),
    tertiary: getCssVariable('--dark-text-tertiary', colors.grey._550),
    disabled: getCssVariable('--dark-text-disabled', colors.grey._900),
    hint: getCssVariable('--dark-text-hint', colors.grey._900),
    link: getCssVariable('--dark-text-link', colors.blue._600),
    light: getCssVariable('--dark-text-light', colors.grey._1000),
    grey: getCssVariable('--dark-text-grey', colors.grey._700),
    greyDark: getCssVariable('--dark-text-greyDark', colors.grey._250),
    status: getCssVariable('--dark-text-status', colors.grey._50),
    staticWhite: getCssVariable('--dark-text-staticWhite', colors.grey._50),
    white: getCssVariable('--dark-text-white', colors.grey._500),
    blue: getCssVariable('--text-blue', colors.blue._650),
    blueLight: getCssVariable('--dark-text-blueLight', colors.blue._650),
    staticBlue: getCssVariable('--dark-text-staticBlue', colors.blue._750),
    red: getCssVariable('--dark-text-red', colors.red._300),
    orange: getCssVariable('--dark-text-orange', colors.orange._300),
    orangeDark: getCssVariable('--dark-text-orangeDark', colors.orange._250),
    deepBlue: getCssVariable('--dark-text-deepBlue', colors.blue._500),
    pink: getCssVariable('--dark-text-pink', colors.pink._100),
    pinkInverted: getCssVariable('--dark-text-pinkInverted', colors.red._200),
    greenDark: getCssVariable('--dark-text-greenDark', colors.green._350),
    deepGreen: getCssVariable('--dark-text-deepGreen', colors.green._350),
    greenLightInverted: getCssVariable('--dark-text-greenLightInverted', colors.green._300),
    purple: getCssVariable('--dark-text-purple', colors.purple._100),
  },
  chips: {
    background: {
      blue: getCssVariable('--chips-background-blue', colors.blue._350),
      red: getCssVariable('--chips-background-red', colors.red._150),
      deepGreen: getCssVariable('--chips-background-deepGreen', colors.blue._400),
      greenDark: getCssVariable('--chips-background-greenDark', colors.green._200),
      purple: getCssVariable('--chips-background-purple', colors.purple._100),
      pink: getCssVariable('--chips-background-pink', colors.pink._50),
      orange: getCssVariable('--chips-background-orange', colors.orange._150),
      yellow: getCssVariable('--chips-background-yellow', colors.yellow._50),
      grey: getCssVariable('--chips-background-greyLight', colors.grey._200),
    },
    text: {
      blue: getCssVariable('--chips-text-blue', colors.blue._800),
      red: getCssVariable('--chips-text-red', colors.red._450),
      green: getCssVariable('--chips-text-green', colors.green._550),
      deepGreen: getCssVariable('--chips-text-deepGreen', colors.blue._850),
      purple: getCssVariable('--chips-text-purple', colors.purple._400),
      pink: getCssVariable('--chips-text-pink', colors.pink._300),
      orange: getCssVariable('--chips-text-orange', colors.orange._450),
      yellow: getCssVariable('--chips-text-yellow', colors.yellow._250),
      greyLight: getCssVariable('--chips-text-greyLight', colors.black._50),
    },
    border: {
      blue: getCssVariable('--chips-border-blue', colors.blue._800),
      red: getCssVariable('--chips-border-red', colors.red._450),
      deepGreen: getCssVariable('--chips-border-deepGreen', colors.blue._850),
      green: getCssVariable('--chips-border-green', colors.green._550),
      purple: getCssVariable('--chips-border-purple', colors.purple._400),
      pink: getCssVariable('--chips-border-pink', colors.pink._300),
      orange: getCssVariable('--chips-border-orange', colors.orange._450),
      yellow: getCssVariable('--chips-border-yellow', colors.yellow._250),
      grey: getCssVariable('--chips-border-grey', colors.black._50),
    },
  },
} as ThemeOptions['palette'];
